export const policy_slice_name = 'POLICY';

export const policy_thunks = {
  POLICY_GET_POLICY_DETAILS: `${policy_slice_name}/getPolicyDetails`,
  POLICY_GET_POLICY_DOCUMENT: `${policy_slice_name}/getPolicyDocument`,
};

export const COVER_SUMMARY_FILENAME = 'Cover Summary';
